import { API_BASE_URL } from "@/config";
import { handle_registration_redirect } from '@/utils/redirects';
import { MAIN_CONTROLLER } from '@/utils/main_controller';

export default {
  name: 'FirstTimePasswordReset',
  mixins: [MAIN_CONTROLLER],
  data: () => ({
    email: '',
    old_password: '',
    new_password: '',
    confirm_password: '',
    show_old_password: false,
    show_new_password: false,
    show_confirm_password: false,
    user_id: null,
    client_admin_id: sessionStorage.getItem('client_admin_id'),
    workflow_id: sessionStorage.getItem('workflow_id'),
    asset_id: sessionStorage.getItem('asset_id'),
  }),

  created() {
    // Get email and user_id from route params or session
    this.email = this.$route.params.email || sessionStorage.getItem('reset_email') || '';
    this.user_id = this.$route.params.user_id || sessionStorage.getItem('reset_user_id') || null;

    // Add client detection logic
    const domain = window.location.hostname;

    if (domain.includes("verify")) {
      this.client = "verify";
    } else if (domain.includes("wizzit")) {
      this.client = "wizzit";
    } else if (domain.includes("mobiafrica")) {
      this.client = "mobiafrica";
    } else if (domain.includes("vodacom")) {
      this.client = "vodacom";
    } else if (domain.includes("weelee")) {
      this.client = "weelee";
    } else if (domain.includes("nutun")) {
      this.client = "nutun";
    } else if (domain.includes("nurturelink")) {
      this.client = "nurturelink";
    } else if (domain.includes("suzuki")) {
      this.client = "suzuki";
    } else if (domain.includes("veersgroup")) {
      this.client = "veersgroup";
    } else if (domain.includes("eaglecorner")) {
      this.client = "eaglecorner";
    } else if (domain.includes("hybridconcepts")) {
      this.client = "hybridconcepts";
    } else if (domain.includes("eeb")) {
      this.client = "eeb";
    } else if (domain.includes("miway")) {
      this.client = "miway";
    } else if (domain.includes("mfo")) {
      this.client = "mfo";
    } else if (domain.includes("ittsc")) {
      this.client = "ittsc";
    } else if (domain.includes("smartsure")) {
      this.client = "smartsure";
    } else if (domain.includes("experian")) {
      this.client = "experian";
    } else if (domain.includes("autocity")) {
      this.client = "autocity";
    } else if (domain.includes("yumbi")) {
      this.client = "yumbi";
    } else if (domain.includes("santam")) {
      this.client = "santam";
    } else if (domain.includes("altron")) {
      this.client = "altron";
    } else if (domain.includes("swift")) {
      this.client = "swift";
    } else if (domain.includes("webuycars")) {
      this.client = "webuycars";
    } else if (domain.includes("neutrinori")) {
      this.client = "neutrinori";
    } else if (domain.includes("getsavvi")) {
      this.client = "getsavvi";
    }

    // Set client-specific data attribute
    if (this.client) {
      document.documentElement.setAttribute("data-client", this.client);
    }
  },
  
  mounted() {
    // Redirect to login if no email present
    if (!this.email) {
      this.$router.push({ name: 'user_login' });
    }
  },

  methods: {
    open_modal() {
      $('#reset-modal').modal('show');
    },

    close_modal() {
      $('#reset-modal').modal('hide');
    },

    toggle_old_password_view() {
      this.show_old_password = !this.show_old_password;
    },

    toggle_new_password_view() {
      this.show_new_password = !this.show_new_password;
    },

    toggle_confirm_password_view() {
      this.show_confirm_password = !this.show_confirm_password;
    },

    showError(message, field = 'reset') {
      $(`.${field}-message`).text(message).removeClass('d-none');
      setTimeout(() => {
        $(`.${field}-message`).text('').addClass('d-none');
      }, 5000);
    },

    validateForm() {
      let isValid = true;

      if (!this.old_password.trim()) {
        this.showError('Please fill in this field', 'old-password');
        isValid = false;
      }

      if (!this.new_password.trim()) {
        this.showError('Please fill in this field', 'new-password');
        isValid = false;
      } else if (this.new_password.length < 8) {
        this.showError('Password must be at least 8 characters long', 'new-password');
        isValid = false;
      }

      if (!this.confirm_password.trim()) {
        this.showError('Please fill in this field', 'confirm-password');
        isValid = false;
      }

      if (this.new_password && this.confirm_password && this.new_password !== this.confirm_password) {
        this.showError('Passwords do not match', 'confirm-password');
        isValid = false;
      }

      return isValid;
    },

    redirect(token, GET_CLIENT_ID) {
      const CHECK_PROCESS_URL = `${API_BASE_URL}/verify_api/system_management_api/user_redirect_api/`;

      $.ajax({
        url: CHECK_PROCESS_URL,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${token}`
        },
        success: (response) => {
          handle_registration_redirect(
            response,
            this.$router,
            this.$store,
            this.fetch_current_service,
            GET_CLIENT_ID
          );
        },
        error: () => {
          return;
        }
      });
    },

    resetPassword() {
      if (!this.validateForm()) {
        return false;
      }

      const RESET_URL = `${API_BASE_URL}/verify_api/system_management_api/first_time_password_reset_api/`;

      const FORM_DATA = {
        email: this.email,
        old_password: this.old_password,
        new_password: this.new_password,
        confirm_password: this.confirm_password
      };

      $.ajax({
        url: RESET_URL,
        method: 'POST',
        data: JSON.stringify(FORM_DATA),
        contentType: 'application/json',
        beforeSend: () => {
          Swal.fire({
            text: 'Resetting password...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.close();
          
          // Clear session storage for reset
          sessionStorage.removeItem('reset_email');
          sessionStorage.removeItem('reset_user_id');
          
          // Store login credentials
          localStorage.clear();
          sessionStorage.clear();
          
          localStorage.setItem('user_id', response.data.user_id);
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user_state', 'logged_in');
          
          this.$store.commit('set_user_role', response.data.user_role);
          
          if (response.data.client_admin_id) {
            sessionStorage.setItem('client_admin_id', response.data.client_admin_id);
          }
          
          if (this.workflow_id) {
            sessionStorage.setItem('workflow_id', this.workflow_id);
          }

          if (this.asset_id) {
            sessionStorage.setItem('asset_id', this.asset_id);
          }

          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Password reset successfully. Please verify your account.',
            confirmButtonText: 'Continue'
          }).then(() => {
            this.$router.push({ name: 'user_otp' });
          });
        },
        error: (error) => {
          Swal.close();
          let error_message = 'Error resetting password';
          
          if (error.responseJSON && error.responseJSON.error) {
            error_message = error.responseJSON.error;
          } else if (error.responseText) {
            try {
              const ERROR_RESPONSE = JSON.parse(error.responseText);
              if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
                error_message = ERROR_RESPONSE.error;
              }
            } catch (e) {
              // Use default error message
            }
          }
          
          this.showError(error_message, 'reset');
        }
      });
    }
  }
};
